import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse,HttpParams } from '@angular/common/http';
import { catchError, lastValueFrom, Observable, throwError } from 'rxjs';
import { Userdetails } from '../../interface/temporaryredelegation/userdetails';
import {UserTempDOA } from '../../interface/temporaryredelegation/user-temp-doa';
import {Redelegation } from '../../interface/temporaryredelegation/redelegation';
import { IDetails } from '../../interface/temporaryredelegation/searchredelegation';
import { environment } from '../../../environments/environment';
import { TempRedelEmployeedetails} from '../../interface/delegationofauthority/employeedetails';
import { ApproveRedelegation,PayrollRedelegationsDetails } from '../../interface/temporaryredelegation/approveredelegation';
const apiUrl = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})export class TemporaryRedelegationService {

  constructor(private http: HttpClient) { }

  getUserDetails(usermail: string): Observable<Userdetails> {
    return this.http.get<Userdetails>(`${apiUrl}/TemporaryReDelegation/GetTempEmpInformation?empNoCaiOrUserId=${usermail}`);
   }
   getSupervisors(divisionID: string): Observable<Userdetails> {
    //return this.http.get<Userdetails[]>(`${apiUrl}/TemporaryReDelegation/GetUserDetails?Usercai=${UserCAI}`);
    return this.http.get<Userdetails>(`${apiUrl}/TemporaryReDelegation/GetSupervisorDetails?DivisionID=${divisionID}`);
   }
  // getUserbyDept(usermail: string,DeprtID:string,divisionid:string): Observable<Userdetails> {
  //   return this.http.get<Userdetails>(`${apiUrl}/TemporaryReDelegation/GetEmployeebyDept?empNoCaiOrUserId=${usermail}&DeptID=${DeprtID}&DivisionID=${divisionid}`);
  // }
  getUserbyDept(delegatorEmail:string,delegateeEmail: string, DeprtID: string, divisionid?: string): Observable<Userdetails> {
    let params = new HttpParams().set('delegatorEmail',delegatorEmail).set('delegateeEmail', delegateeEmail).set('DeptID', DeprtID);
    if (divisionid) {
      params = params.set('DivisionID', divisionid);
    }
    return this.http.get<Userdetails>(`${apiUrl}/TemporaryReDelegation/GetEmployeebyDept`, { params });
  }
  getUserRedelegationDetails(frommail:string,EnteredDate:Date): Observable<Redelegation> {
    return this.http.get<Redelegation>(`${apiUrl}/TemporaryReDelegation/GetUserRedelegationdetails?frommail=${frommail}&EnteredDate=${EnteredDate}`);
  }

  getUserApproverDetails() {
    return this.http.get<string>(`${apiUrl}/TemporaryReDelegation/GetApproverDetails`);
  }
  showDelegateeDelegations(toEmail:string): Observable<Redelegation[]> {
    const url = `${apiUrl}/TemporaryReDelegation/ShowDelegateeDelegation?toEmail=${toEmail}`;
    return this.http.get<Redelegation[]>(url);
  } 
  
  getDelegatorDelegations(toEmail:string): Observable<Redelegation[]> {
    const url = `${apiUrl}/TemporaryReDelegation/GetDelegatorDelegations?toEmail=${toEmail}`;
    return this.http.get<Redelegation[]>(url);
  } 
  getReDelegationHistory(frommail: string, EnteredDate: Date): Observable<Redelegation[]> {
    return this.http.get<Redelegation[]>(`${apiUrl}/TemporaryReDelegation/GetUserRedelegationdetails?frommail=${frommail}&EnteredDate=${EnteredDate}`);
   
    }
  
    showReDelegations(fromEmail:string): Observable<Redelegation[]> {
      const url = `${apiUrl}/TemporaryReDelegation/ShowDelegation?fromEmail=${fromEmail}`;
      return this.http.get<Redelegation[]>(url);
    } 
  saveRedelegation(object:any) {
    const url = `${apiUrl}/TemporaryReDelegation/SaveDOA`;
    return this.http.post<boolean[]>(url,object,{
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  
    getEmployeeDetails(empNoCaiOrUserId: string): Observable<TempRedelEmployeedetails> {
      const url = `${apiUrl}/TemporaryReDelegation/GetTempEmpInformation?empNoCaiUserIdOrName=${empNoCaiOrUserId}`;
      return this.http.get<TempRedelEmployeedetails>(url);
    }
    updateRedelegation(obj: any) {
      const url = `${apiUrl}/TemporaryReDelegation/UpdateDOA`;
      return this.http.post<boolean[]>(url, obj, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    
  deleteRedelgation(obj: any) {
    const url = `${apiUrl}/TemporaryReDelegation/DeleteDOA`;
    return this.http.request<boolean[]>('delete', url, {
      body: obj,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  getDetails(params: any): Observable<IDetails[]> {
    const queryParams = new URLSearchParams();
    for (const key in params) {
      if (params[key]) {
        queryParams.append(key, params[key]);
      }
    }
    return this.http.get<IDetails[]>(`${apiUrl}/TemporaryReDelegation/searchRedelegation?${queryParams.toString()}`);
  }

  getVwPerviewReportWorkSheet(dataSource: any[]): Observable<Blob> {
    const url = `${apiUrl}/TemporaryReDelegation/GetDOAVwPerviewReportWorkSheet`;
    return this.http.post(url, dataSource, { responseType: 'blob' }).pipe(
    catchError((error: HttpErrorResponse) => {
    console.error('Error generating Excel file', error);
    return throwError(() => new Error('Error generating Excel file'));
    })
   );
 }
 getRedelegations(): Observable<ApproveRedelegation[]> {
     return this.http.get<ApproveRedelegation[]>(`${apiUrl}/TemporaryReDelegation/redelegations`);
   }
 
   getRedelegationDetails(nEmpNo: string, eDate: string): Observable<ApproveRedelegation> {
     return this.http.get<ApproveRedelegation>(`${apiUrl}/TemporaryReDelegation/details`, {
       params: { nEmpNo, eDate}
     });
   }
 
   getRedelegationHistoryDetails(nEmpNo: string,eDate: string): Observable<ApproveRedelegation[]> {
     return this.http.get<ApproveRedelegation[]>(`${apiUrl}/TemporaryReDelegation/historydetails`, {
       params: { nEmpNo,eDate }
     });
   }
 
   saveRedelegationAction(nEmpNo: string, action: string, sLogonCAI: string, eDate: string, sCmt?: string, sReqCAI?: string): Observable<any> {
    const payload = {
      nEmpNo,
      action,
      sLogonCAI,
      eDate,
      sCmt,
      sReqCAI,
    };
    return this.http.post<any>(`${apiUrl}/TemporaryReDelegation/saveredelegationaction`, payload);
  }
 
 getApprovedRedelegations(dStartDate: string, dEndDate: string): Observable<PayrollRedelegationsDetails[]> {
  return this.http.get<PayrollRedelegationsDetails[]>(`${apiUrl}/TemporaryReDelegation/redelegationsapproved`, {
    params: { dStartDate, dEndDate }
  });
} 

 GenerateRedelegationsExcelReport(dStartDate: string, dEndDate: string): Observable<Blob> {
  const url = `${apiUrl}/TemporaryReDelegation/redelegationsapproved/excel?dStartDate=${dStartDate}&dEndDate=${dEndDate}`;
  return this.http.get(url, { responseType: 'blob' }).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('Error downloading Excel file', error);
      return throwError(() => new Error('Error downloading Excel file'));
    })
  );
}

processPayment(payMonth: string, sLogonEmail: string, dStartDate: string, dEndDate: string, enteredDate: string): Observable<any> {
  return this.http.put(`${apiUrl}/TemporaryReDelegation/UpdateRedelegationRecordsForPayment`, null, {
    params: { payMonth, sLogonEmail, dStartDate, dEndDate, enteredDate },
    responseType: 'text' as 'json' // Change responseType to 'text'
  });
}
getEmployeeDetailsByEmail(email: string): Observable<TempRedelEmployeedetails> {
      const url = `${apiUrl}/TemporaryReDelegation/GetTempEmpInformationByEmail?email=${email}`;
      return this.http.get<TempRedelEmployeedetails>(url);
    }
}
